import type { JSX } from 'react'

import { useLayoutEffect } from 'react'
import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBoxMaxLine2FontSmBold } from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { SearchAutocompleteItemSC } from './SearchAutocompleteItem.styled'
import { useSearchAutocompleteList } from './SearchAutocompleteListContext'

export interface ISearchAutocompleteItemProps {
  suggestionText: string
  onPick: () => void
  listIndex?: number
}

export const SearchAutocompleteItem = ({
  suggestionText,
  onPick,
  listIndex,
}: ISearchAutocompleteItemProps): JSX.Element => {
  const list = useSearchAutocompleteList()

  useLayoutEffect(() => {
    if (list == null || listIndex === undefined) return
    list.setPick(listIndex, onPick)
    return () => list.setPick(listIndex, null)
  }, [list, listIndex, onPick])

  const isHighlighted =
    list != null &&
    listIndex !== undefined &&
    list.highlightedIndex === listIndex

  const onMouseEnter =
    list != null && listIndex !== undefined
      ? () => list.setHighlightedIndex(listIndex)
      : undefined

  const onMouseLeave =
    list != null && listIndex !== undefined
      ? () =>
          list.setHighlightedIndex((prev) => (prev === listIndex ? null : prev))
      : undefined

  return (
    <SearchAutocompleteItemSC
      role='option'
      aria-selected={isHighlighted}
      data-highlighted={isHighlighted ? 'true' : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onPick}
    >
      <Icon
        name={IconNames.search}
        size={IconSizes.xSm}
        color={Colors.TEXT_ICON_PRIMARY}
      />

      <TextBoxMaxLine2FontSmBold
        title={suggestionText}
        color={Colors.TEXT_ICON_PRIMARY}
      />
    </SearchAutocompleteItemSC>
  )
}
